import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'services/authentication';
import './Debug.scss';

const Debug: FC = () => {
    const { user } = useAuth();

    let revisionText: string;

    if (location.hostname === 'localhost') {
        revisionText = 'local development';
    } else {
        revisionText = user?.admin.version ?? 'Unable to fetch. You must be logged in as admin.';
    }

    return (
        <div className="debug" data-testid="debug">
            <span className="debug__item">
                <span className="debug__title">revision:</span>
                <span className="debug__value debug--revision">{revisionText}</span>
            </span>
            <span className="debug__item">
                <span className="debug__title">dev nav:</span>
                <span className="debug__value">
                    <Link to={'/'}>home</Link> |&nbsp;
                    <Link to={'/dashboards'}>view all dashboards</Link> |&nbsp;
                    <Link to={'/admin'}>admin</Link>
                </span>
            </span>
        </div>
    );
};

export default Debug;
